export default __webpack_public_path__ + "static/media/Ashoka_Particle_Flame_4.1be23963.png";